var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterstitialBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "1em",
    viewBox: "0 0 2384 1200",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "interstitial-bg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2384v1200H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#interstitial-bg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2384v1200H0z",
    fill: "#2d5588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084 1h265l241 300h-270.1z",
    fill: "#2d5588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348 1h270.82L1860 301h-270.31z",
    fill: "#102240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619 1h269.28L2129 301h-269.79z",
    fill: "#1c355a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 1h270.818L1055 301H784.693z",
    fill: "#1d3e68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874 1h269.28L2384 301h-269.79z",
    fill: "#3d76a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2143 1l323-1v301h-82z",
    fill: "#1c355a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 1h275.93L1320 301h-270.31z",
    fill: "#183455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0l271.818 1L513 301H259.044z",
    fill: "#1d3e68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 1h276.118L785 301H507.859z",
    fill: "#4896c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082 1200h265l241-301h-270.1z",
    fill: "#1d3e68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346 1200h270.82L1858 899h-270.31z",
    fill: "#2d5588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618 1200h268.75L2127 899h-269.26z",
    fill: "#1c355a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 1200h270.818L1054 899H783.693z",
    fill: "#2d5588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1887 1200h269.81L2398 899h-270.32z",
    fill: "#4896c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2158 1200h306V900.024L2397.48 899z",
    fill: "#2a5e9b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 1200h275.39L1318 899h-269.78z",
    fill: "#1e375f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 1200h265.318L507 899l-248.846.512z",
    fill: "#2d5588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 1200h275.586L783 899H506.393z",
    fill: "#1a2f51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 601h264.75L1587 901h-269.34z",
    fill: "#6db9e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347 601h270.57L1857 901h-270.06z",
    fill: "#1f4e7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619 601h268.23L2126 901h-268.77z",
    fill: "#152546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 601h270.616L1048 901l-263.978-.511z",
    fill: "#3d76a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888 601h269.82L2398 900.489l-270.84.511z",
    fill: "#6db9e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 601h275.68L1317 901h-269.55z",
    fill: "#1c2e53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 601h270.818L512 901H258.044z",
    fill: "#1d3e68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 601h275.858L783 900.489 506.631 901z",
    fill: "#e3773b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 601h265l241-300h-270.1z",
    fill: "#ac3160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347 601h270.82L1859 301h-270.31z",
    fill: "#1d3e68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619 601h268.75L2128 301h-269.26z",
    fill: "#1c355a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 601h270.818L1054 301H783.693z",
    fill: "#1c2e53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888 601h269.53L2400 301h-270.55z",
    fill: "#152546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2154 601h269.82L2664 900.489l-270.84.511zM2154 601h269.53L2666 301h-270.55z",
    fill: "#3d76a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 601h275.93L1319 301h-270.31z",
    fill: "#102240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 601h270.818L512 301H258.044z",
    fill: "#3d76a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 601h276.118L784 301H506.859z",
    fill: "#d15d32"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2f6aac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2347 601h269.82L2857 900.489l-270.84.511zM2347 601h269.53L2859 301h-270.55z"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgInterstitialBg as ReactComponent };